const listeners = [];
let observer;
const doc = window.document;
const MutationObserver = window.MutationObserver || window.WebKitMutationObserver;

function check() {
    for (let i = 0, len = listeners.length, listener, elements; i < len; i++) {
        listener = listeners[i];
        elements = doc.querySelectorAll(listener.selector);
        for (let j = 0, jLen = elements.length, element; j < jLen; j++) {
            element = elements[j];
            if (!element.ready) {
                element.ready = true;
                listener.fn.call(element, element);
            }
        }
    }
}

export default function domReady(selector, fn) {
    listeners.push({
        selector,
        fn,
    });
    if (!observer) {
        // Watch for changes in the document
        observer = new MutationObserver(check);
        observer.observe(doc.documentElement, {
            childList: true,
            subtree: true,
        });
    }
    // Check if the element is currently in the DOM
    check();
}
